import TEvaluate from './evaluate.vue'

TEvaluate.install = Vue => {
  Vue.component(TEvaluate.name, TEvaluate)
}
export default TEvaluate



// WEBPACK FOOTER //
// ./src/module/evaluate/index.js